import { Card, CardContent, Grid, Tooltip } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import "./scoreCard.css"
import { Stack } from "@mui/material";
import React, { useState } from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { IoIosArrowDown } from "react-icons/io";
import newStyleCred from "./ScoreDetailsPage.style";
import htdf from "../../assets/images/hdfc.png";
import axis from "../../assets/images/axis.png";
import icici from "../../assets/images/icici.png";
import kotak from "../../assets/images/kotak.png";
import indusind from "../../assets/images/indusind.png";
import idfc from "../../assets/images/idfc.png";
import sbi from "../../assets/images/sbi.png";
import rbl from "../../assets/images/rlb.png";
import yesBank from "../../assets/images/yesbank.png";
import avatar from "../../assets/images/previewAvatar.png";
import bankLogo from "../../assets/images/BankLogo.png";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const ScoreCard = (props) => {
  // console.log("ScoreCard:=>",props)
  const theme = useTheme();
  const [openDetails, setOpenDetails] = useState(false);
  const showHistory = () => {
    setOpenDetails(true);
  };
  const hideHistory = () => {
    setOpenDetails(false);
  };
  let date = new Date();
  const month = date.toLocaleString("default", { month: "short" });
  // console.log("prop=>", props, date.getFullYear(), month);
  let currentMonth = month;
  let currentYear = date.getFullYear();
  const newCreditStyle = newStyleCred();

  return (
    <Grid item lg={6} md={6} sm={12} xs={12} >
      
      <div style={{padding:10, borderRadius: "10px",
          border: "0.3px solid lightgrey", width:"100%" , marginTop:10}}>
         <div style={{display: "flex", flexDirection: "row" , justifyContent: "space-between" , alignItems:"center", width: "100%"}}>
          <img
                  src={
                    props?.data?.lenderName?.toLowerCase().includes("hdfc")
                      ? htdf
                      : props?.data?.lenderName?.toLowerCase().includes("axis")
                      ? axis
                      : props?.data?.lenderName?.toLowerCase().includes("icici")
                      ? icici
                      : props?.data?.lenderName?.toLowerCase().includes("kotak")
                      ? kotak
                      : props?.data?.lenderName
                          ?.toLowerCase()
                          .includes("indusind")
                      ? indusind
                      : props?.data?.lenderName?.toLowerCase().includes("idfc")
                      ? idfc
                      : props?.data?.lenderName?.toLowerCase().includes("sbi")
                      ? sbi
                      : props?.data?.lenderName?.toLowerCase().includes("yes")
                      ? yesBank
                      : props?.data?.lenderName?.toLowerCase().includes("rbl")
                      ? rbl
                      : bankLogo
                  }
                  height="35px"
                />
                  {props?.data?.status === "Active" ? (
              
                <div
                  style={{
                    backgroundColor: "rgba(0, 211, 59, 0.1)",
                    padding: "7px",
                    borderRadius: "29px",
                    height: "40px",
                    width: "80px",
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#0AC23E",
                      fontWeight: 600,
                    }}
                  >
                    {props?.data?.status}
                  </span>
                </div>
              
            ) : (
              
                <div
                  style={{
                    backgroundColor: "#f8d7da",
                    padding: "7px",
                    borderRadius: "29px",
                    height: "40px",
                    width: "80px",
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#842029",
                      fontWeight: 600,
                    }}
                  >
                    {props?.data?.status}
                  </span>
                </div>
            )}
         </div>
         <div style={{display:"flex", flexDirection:"column"}}>
         <div style={{fontSize: "16px",fontWeight: 600,
        //  marginLeft: "10px"
         }}>
          {props?.data?.lenderName} | {props?.data?.accountType}</div><div><span
                    style={{
                      // marginLeft: "10px",
                      fontWeight: 500,
                      fontSize: "12px",
                    }}
                  >
                    <span style={{ color: "grey" }}>Account Number</span>:{" "}
                    <span style={{ fontWeight: 500 }}>
                      {props?.data?.accountNumber}
                    </span>
                  </span></div>
         </div>

         <div style={{display:"flex", flexDirection:"row",justifyContent: "space-between", borderBottom: "1px solid lightgrey"}}>
          <div className="cardContainerText">Holder Type</div><div className="cardContainerText">{props?.data?.holderType}</div>
         </div>

         <div style={{display:"flex", flexDirection:"row",justifyContent: "space-between", borderBottom: "1px solid lightgrey"}}>
          <div className="cardContainerText">Age of Account</div><div className="cardContainerText">{props?.data?.ageAccount}</div>
         </div>

         <div style={{display:"flex", flexDirection:"row",justifyContent: "space-between", borderBottom: "1px solid lightgrey"}}>
          <div className="cardContainerText">Last Payment Date</div><div className="cardContainerText">{props?.data?.lastUpdated
                      ? props?.data?.lastUpdated
                      : "----"}</div>
         </div>

         <div style={{display:"flex", flexDirection:"row",justifyContent: "space-between", borderBottom: "1px solid lightgrey"}}>
          <div className="cardContainerText">Last Reporting Date</div><div className="cardContainerText">{props?.data?.reportingDate
                      ? props?.data?.reportingDate
                      : "----"}</div>
         </div>
        
         <div style={{display:"flex", flexDirection:"row",justifyContent: "space-between"}}>
          <div className="cardContainerText">Limit</div><div className="cardContainerText">{props?.data?.limit ? props?.data?.limit : "----"}</div>
         </div>

         <hr
            style={{ width: "100%", border: "0.1px solid", opacity: "0.1" }}
          />

      
          {!openDetails && (
            <div
              style={{
                textAlign: "center",
                fontSize: "16px",
                fontWeight: 600,
                color: "#2B378D",
              }}
              onClick={showHistory}
            >
              
              <div style={{ fontWeight: 600, cursor: "pointer" }}>
                View Details <IoIosArrowDown />
              </div>
            </div>
          )}
          {openDetails === true && (
            <div
              style={{
                // overflow: "auto",
                // flexWrap: "nowrap",
                // textAlign: "center"
              }}
            >
              <div className="" style={{backgroundColor: "#f2f2f2", padding:12, borderRadius: 4}}>
                <div style={{ fontSize: "14px", fontWeight: 600 }}>
                  Payment history of this account
                </div>
                <Grid container style={{ width: "100%" }}>
                <Grid item lg={4} md={4} sm={12} xs={12} >
                    <span>
                      <CheckCircleOutlineIcon fontSize="5px"
                        style={{ color: "#0AC23E" }}
                      />
                    </span>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        
                      }}
                    >
                      Paid on time
                    </span>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12} >
                    <span style={{ }}>
                      <ErrorOutlineIcon fontSize="5px"
                        style={{ color: "#E49F17" }}
                      />
                    </span>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        paddingLeft: "1%",
                      }}
                    >
                      1-89 days late
                    </span>
                </Grid>
                <Grid item lg={4} md={4} sm={12} xs={12} >
                    <span style={{  }}>
                      <ErrorOutlineIcon fontSize="5px"
                        style={{ color: "#EB2B00"  }}
                      />
                    </span>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        paddingLeft: "1%",
                      }}
                    >
                      More than 90 days late
                    </span>
                </Grid>  
                </Grid>
              </div>

              {Object.keys(props?.data?.paymentHistoryDate)
                .reverse()
                .map((year) => {
                  return (
                    <div
                      className="calPad"
                      style={{
                        // padding:2,
                        display: "flex",
                        // justifyContent: "space-evenly",
                        marginTop: "2%",
                        maxWidth: "100%",
                        // backgroundColor:"red",
                        // border:'1px solid green',
                        // overflow: "auto",
                        overflowY:"scroll",
                        flexWrap: "nowrap",
                      }}
                    >
                      <div className={newCreditStyle.circle}>
                        <span></span>
                      </div>
                      <div className={newCreditStyle.fontStyle}>
                        <span
                          style={{
                            color: "#2B378D",
                            textDecoration: "underline 2px solid",
                            fontWeight: 600,
                          }}
                        >
                          {year}
                        </span>
                      </div>

                      {props?.data?.paymentHistoryDate[year].includes("Jan") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Jan</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Jan" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Jan</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Feb") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Feb</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Feb" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Feb</div>
                      )}
                      {props?.data?.paymentHistoryDate[year].includes("Mar") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Mar</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Mar" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Mar</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Apr") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Apr</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Apr" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Apr</div>
                      )}
                      
                      {props?.data?.paymentHistoryDate[year].includes("May") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>May</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "May" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>May</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Jun") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Jun</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Jun" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Jun</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Jul") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Jul</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Jul" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Jul</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Aug") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Aug</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Aug" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Aug</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Sep") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Sep</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Sep" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Sep</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Oct") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Oct</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Oct" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Oct</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Nov") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Nov</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Nov" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Nov</div>
                      )}

                      {props?.data?.paymentHistoryDate[year].includes("Dec") ? (
                        <div className={newCreditStyle.fontStyle}>
                          <Stack>
                            <span>Dec</span>
                            <span className={newCreditStyle.iconStyle}>
                              {props?.data?.duesDaysCountArray.map((data) => {
                                return data?.year === year &&
                                  data?.month === "Dec" ? (
                                  data?.data &&
                                  parseInt(data?.data) > 0 &&
                                  parseInt(data?.data) < 90 ? (
                                    data?.data ? (
                                      <Tooltip
                                        title={data?.data + " days late"}
                                        aria-label={data?.data + " days late"}
                                        placement="bottom"
                                      >
                                        <ErrorOutlineIcon
                                          style={{
                                            width: "16px",
                                            color: "#E49F17",
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        style={{ width: "16px" }}
                                      />
                                    )
                                  ) : data?.data && data?.data > 90 ? (
                                    <Tooltip
                                      title={data?.data + " days late"}
                                      aria-label={data?.data + " days late"}
                                      placement="bottom"
                                    >
                                      <ErrorOutlineIcon
                                        style={{
                                          width: "4%",
                                          color: "#EB2B00",
                                        }}
                                      />
                                    </Tooltip>
                                  ) : (
                                    <CheckCircleOutlineIcon
                                      style={{ width: "16px" }}
                                    />
                                  )
                                ) : (
                                  ""
                                );
                              })}
                            </span>
                          </Stack>
                        </div>
                      ) : (
                        <div className={newCreditStyle.fontStyle}>Dec</div>
                      )}
                    </div>
                  );
                })}
              <div
                className={newCreditStyle.closeBtn}
                onClick={() => hideHistory()}
              >
                <div>Close Details</div>
              </div>
            </div>
          )}
          
      </div>
    </Grid>
  );
};

export default ScoreCard;
